export const invoiceListAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }